import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShopContext } from "../../context/ShopContext";

const subtitle = "Furious-9 Merch";
const title = "Explore Our Products";

const ProductSection = () => {
  const { products, currency } = useContext(ShopContext);
  const [latestProducts, setLatestProducts] = useState([]);

  useEffect(() => {
    if (products.length) {
      setLatestProducts(products.slice(0, 8));
    }
  }, [products]);

  return (
    <div className="product-section padding-top padding-bottom">
      <div className="container">

      <div className="section-header">
        <p className="text-anim-fade-down js-animate delay-sm">
          {subtitle}
        </p>

        <h2 className="text-anim-typing js-animate delay-md">
          {title}
        </h2>
      </div>


        <div className="section-wrapper">
          <div className="row g-4 justify-content-center">

            {latestProducts.map((product) => (
              <div
                className="col-xl-3 col-md-4 col-sm-6 col-12"
                key={product._id}
              >
                <div className="product-item frame-card">

                  {/* TOP FRAME */}
                  <img
                    src="/assets/images/frame/top-frame.png"
                    className="frame-top"
                    alt=""
                  />

                  <div className="product-inner">
                    <div className="product-thumb">
                      <img
                        src={product.image?.[0] || "/assets/images/shop/placeholder.png"}
                        alt={product.name}
                        className="w-100"
                      />
                    </div>

                    <div className="product-content text-center p-3">
                      <Link to={`/shop-single/${product._id}`}>
                        <h5 className="product-title">{product.name}</h5>
                      </Link>
                      <h5 className="product-price">
                        {currency}{product.price}
                      </h5>
                    </div>
                  </div>

                  {/* BOTTOM FRAME */}
                  <img
                    src="/assets/images/frame/bottom-frame.png"
                    className="frame-bottom"
                    alt=""
                  />

                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </div>
  );
};

export default ProductSection;
